export interface Story {
  id: string
  year: string
  title: string
  snippet: string
  author: {
    name: string
    avatar: string
  }
  photo?: string
}

export const storiesData: Story[] = [
  {
    id: 's1',
    year: '1962',
    title: 'The Long Boat Ride',
    snippet:
      'Amma packed only two suitcases and a tin of homemade spices when she left Kerala. She said the ocean smelled different once they crossed into new waters.',
    author: {
      name: 'Amma',
      avatar:
        'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=100&h=100',
    },
    photo:
      'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&q=80&w=600',
  },
  {
    id: 's2',
    year: '1975',
    title: 'The First Mango Harvest',
    snippet:
      'Appa planted the tree the year Priya was born. Ten years later, it finally bore fruit. We ate them sitting on the porch steps, juice running down our chins.',
    author: {
      name: 'Appa',
      avatar:
        'https://images.unsplash.com/photo-1532073150508-0c1df0221c21?auto=format&fit=crop&q=80&w=100&h=100',
    },
  },
  {
    id: 's3',
    year: '1988',
    title: 'Meeting at Victoria Station',
    snippet:
      'Arun dropped his camera lens. Priya picked it up. They missed their respective trains and ended up getting coffee instead.',
    author: {
      name: 'Priya',
      avatar:
        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=100&h=100',
    },
    photo:
      'https://images.unsplash.com/photo-1515002246390-7bf7e8f87b54?auto=format&fit=crop&q=80&w=600',
  },
  {
    id: 's4',
    year: '1995',
    title: "Maya's Arrival",
    snippet:
      "A thunderstorm raged the night Maya was born. The hospital lost power for ten minutes, but she didn't cry once.",
    author: {
      name: 'Arun',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=100&h=100',
    },
  },
  {
    id: 's5',
    year: '2004',
    title: "Raj's First Concert",
    snippet:
      'He played at a tiny pub downtown. Only five people showed up, but three of them were us. He played like it was Wembley Stadium.',
    author: {
      name: 'Raj',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100&h=100',
    },
    photo:
      'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&q=80&w=600',
  },
  {
    id: 's6',
    year: '2015',
    title: 'Saying Goodbye to Appa',
    snippet:
      'We scattered his ashes near the roots of his favorite mango tree. The next spring, it bloomed more vibrantly than it ever had before.',
    author: {
      name: 'Me (Rohan)',
      avatar:
        'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&q=80&w=100&h=100',
    },
  },
]
